<template><div class="k-hr" :class="`k-hr--${skin} k-hr--${size}`"></div></template>
<style>
.k-hr {
  font-size: 0;
  clear: both;
}
.k-hr--gray {
  background: #fafafa;
  /* background: #FAFAFA; */
}
.k-hr--white {
  background: #fff;
}
.k-hr--inherit {
  background: inherit;
}
.k-hr--1 {
  height: 1px;
}
.k-hr--2 {
  height: 2px;
}
.k-hr--10 {
  height: .1rem;
}
.k-hr--20 {
  height: .2rem;
}
.k-hr--30 {
  height: .3rem;
}
.k-hr--40 {
  height: .4rem;
}
.k-hr--50 {
  height: .5rem;
}
.k-hr--80 {
  height: .80rem;
}
.k-hr--88 {
  height: .88rem;
}
.k-hr--100 {
  height: 1rem;
}
</style>

<script>
  export default {
    name: 'k-hr',
    props: {
      skin: {type: String, default: 'gray'},
      size: {type: String, default: '20'}
    },
    computed: {

    },
    methods: {
      
    },
    created() {

    }
  }

</script>
